import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);

export const FxProgressBar = (props) => {
  const { percent , baseNum} = props;
  const [inputDatas, setInputDatas] = React.useState({});

  const options = {
      title: {
        text: '',
        align: 'left',
        margin: 0,
      },
      chart: {
        renderTo: 'container',
        type: 'bar',
        height: 40,
        backgroundColor : 'transparent'
      },
      credits: false,
      tooltip: false,
      legend: false,
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      xAxis: {
        visible: false,
      },
      yAxis: {
        visible: false,
        min: 0,
        max: 100,
      },
      series: [{
        data: [100],  
        grouping: false,
        animation: false,
        enableMouseTracking: false,
        showInLegend: false,
        color: 'lightskyblue',
        pointWidth: 25,
        borderWidth: 0,
        borderRadiusTopLeft: '4px',
        borderRadiusTopRight: '4px',
        borderRadiusBottomLeft: '4px',
        borderRadiusBottomRight: '4px',
        dataLabels: {
          className: 'highlight',
          format: '10MB',
          enabled: true,
          align: 'right',
          style: {
            color: 'black',
            textOutline: false,
          }
        }
      }, {
        enableMouseTracking: false,
        data: [percent],
        borderRadiusBottomLeft: '4px',
        borderRadiusBottomRight: '4px',
        color: 'navy',
        borderWidth: 0,
        pointWidth: 25,
        animation: {
          duration: 250,
        },
        dataLabels: {
          enabled: true,
          inside: true,
          align: 'left',
          format: '{point.y:.3f}%',
          style: {
            color: 'white',
            textOutline: false,
          }
        }
      }]
    };

    return (
      <HighchartsReact
        className="HighChart"  
        highcharts={Highcharts}
        options={options}
      />
    );
  }

  export default FxProgressBar;
